import { registerBrick, BrickContext } from 'olympe';
import { ReactBrick, useProperty } from '@olympeio/core';
import React, { useEffect, useState } from 'react';
import { Typography, CircularProgress, ThemeProvider } from '@mui/material';
import { WBSAccordion } from './WBSAccordion.jsx';
import { BackendErrorAlert } from '../shared/BackendErrorAlert.jsx';
import { buttonsTheme } from '../shared/_theme.jsx';

export default class MainWBSAccordion extends ReactBrick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array<*>} properties
     * @returns {Element}
     */

    static getReactComponent($) {
        return (props) => {
            const isOpen = useProperty($, 'Is Wbs Accordion Open');
            const loading = useProperty($, 'Loading');
            const wbsData = useProperty($, 'Data');

            const [openNoFetchAlert, setOpenNoFetchAlert] = useState(false);

            useEffect(() => {
                if (wbsData && wbsData.flat(1).length === 0) {
                    setOpenNoFetchAlert(true);
                }
            }, [wbsData]);

            const handleCloseNoFetchDialog = () => {
                setOpenNoFetchAlert(false);
            };

            return (
                <ThemeProvider theme={buttonsTheme}>
                    <div className={'accordion-container show-scrollbar'}>
                        {loading ? (
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'flex-start',
                                }}
                            >
                                <CircularProgress color="primary" sx={{ margin: '1vw' }} />
                                <Typography variant="h5" color="primary">
                                    Loading...
                                </Typography>
                            </div>
                        ) : (
                            isOpen &&
                            wbsData &&
                            wbsData.length > 0 &&
                            wbsData
                                .flat(1)
                                .sort((a, b) => a.PrnNo - b.PrnNo)
                                .map((wbs, idx) => {
                                    const key =
                                        idx +
                                        (wbs.PrnNo ? wbs.PrnNo : wbs.CostElementId) +
                                        (wbs.PrnName ? wbs.PrnName : wbs.CostElementDescription);
                                    return (
                                        <WBSAccordion
                                            key={key}
                                            wbs={wbs}
                                            accordionIdx={idx}
                                            loading={loading}
                                            context={$}
                                        />
                                    );
                                })
                        )}
                        {openNoFetchAlert && (
                            <BackendErrorAlert
                                title={'Fetch Error'}
                                open={openNoFetchAlert}
                                onClose={handleCloseNoFetchDialog}
                                mainLine={BackendErrorAlert.NO_RESULTS_EXPLANATION}
                                smallLine1={BackendErrorAlert.CHANGE_CRITERIA}
                            />
                        )}
                    </div>
                </ThemeProvider>
            );
        };
    }
}

registerBrick('018017e40b900457bc6e', MainWBSAccordion);
